import { memo } from 'react';
import { InfoBlockLoaderWrapper } from './InfoBlockSkeletonLoader.styles';

export const InfoBlockSkeletonLoader = memo((props: { CARD_COUNT: number }) => (
  <InfoBlockLoaderWrapper className="container">
    <div className="skeleton-loader info-block_header" />
    <div className="skeleton-loader info-block_subheader" />
    <div className="info-block_container">
      {Array.from({ length: props.CARD_COUNT }, (_, index) => (
        <div key={index} className="skeleton-loader info-block_card" />
      ))}
    </div>
  </InfoBlockLoaderWrapper>
));

InfoBlockSkeletonLoader.displayName = 'InfoBlockSkeletonLoader';

export default InfoBlockSkeletonLoader;
